package streetlight.web.model

import kampfire.api.Password
import kampfire.api.toValidOutcome
import kampfire.model.Outcome
import kampfire.model.Problem
import kampfire.model.mutableTapOf
import kampfire.model.storeOf

/** A password field with its confirmation. */
class PasswordEditor() {
    private val state = storeOf(PasswordEditorState())
    private val stateNow get() = state.now

    val passwordField = state.mutableTapOf({ it.password }) { copy(password = it) }
    val confirmationField = state.mutableTapOf({ it.confirmation }) { copy(confirmation = it) }

    fun clear() {
        state.set { copy(password = "", confirmation = "")}
    }

    /** The password, validated, or a problem when the confirmation differs. */
    fun getOutcome(): Outcome<Password> = when {
        stateNow.password != stateNow.confirmation -> Problem("Password input does not match")
        else -> Password(stateNow.password).toValidOutcome()
    }
}

data class PasswordEditorState(
    val password: String = "",
    val confirmation: String = "",
)